import React, { useState, useEffect } from 'react';
import DespachoTurno from './DespachoTurno';
import './Despacho.css';

const DespachoInicio = ({ usuario }) => {
  const [turnoActivo, setTurnoActivo] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [exito, setExito] = useState(null);

  useEffect(() => {
    cargarTurnoActivo();
  }, []);

  const cargarTurnoActivo = async () => {
    setCargando(true);
    try {
      const response = await fetch('/api/despacho/turno/activo', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success === true && data.turno) {
        setTurnoActivo(data.turno);
      } else {
        setTurnoActivo(null);
      }
    } catch (err) {
      console.error('Error al cargar turno activo:', err);
      setTurnoActivo(null);
    } finally {
      setCargando(false);
    }
  };

  const handleTurnoAbierto = (turnoNuevo) => {
    setTurnoActivo(turnoNuevo);
    setExito('Turno abierto correctamente');
    setTimeout(() => setExito(null), 3000);
  };

  const handleTurnoCerrado = () => {
    setTurnoActivo(null);
    setExito('Turno cerrado correctamente');
    setTimeout(() => setExito(null), 3000);
  };

  const handleError = (error) => {
    setError(error);
    setTimeout(() => setError(null), 5000);
  };

  if (cargando) {
    return (
      <div className="despacho-container">
        <div className="despacho-loading">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="despacho-container">
      {error && (
        <div className="despacho-alert alert-error">
          <strong>Error:</strong> {error}
        </div>
      )}

      {exito && (
        <div className="despacho-alert alert-success">
          {exito}
        </div>
      )}

      <DespachoTurno
        usuario={usuario}
        turnoActivo={turnoActivo}
        onTurnoAbierto={handleTurnoAbierto}
        onTurnoCerrado={handleTurnoCerrado}
        onError={handleError}
      />
    </div>
  );
};

export default DespachoInicio;
